import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";

import createEducationBarStorage from "../../../education-bar/services/storage/factory";

export default function createOpportunityListsStorage(storageProvider: ModuleStorage) {
    return createEducationBarStorage(storageProvider, {
        isOpenByDefault: false,
    });
}
